import { fillVariants } from "../../../../styles/utils/fill"
import { classNames } from "../../../../utils"
import type { IconProps } from "../../../types"

export function LinkOff({
  size = 24,
  fill = "current",
  fillAttribute = "currentColor",
  className,
  ...rest
}: IconProps) {
  return (
    <svg
      aria-label="Link Off"
      className={classNames(fillVariants({ fill }), className)}
      fill={fillAttribute}
      height={size}
      role="img"
      viewBox="0 -960 960 960"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path d="m770-302-60-62q40-11 65-42.5t25-73.5q0-50-35-85t-85-35H520v-80h160q83 0 141.5 58.5T880-480q0 57-29.5 105T770-302ZM634-440l-80-80h86v80h-6ZM792-56 56-792l56-56 736 736-56 56ZM440-280H280q-83 0-141.5-58.5T80-480q0-69 42-123t108-71l74 74h-24q-50 0-85 35t-35 85q0 50 35 85t85 35h160v80ZM320-440v-80h65l79 80H320Z" />
    </svg>
  )
}
